<div class="device-body light-theme">
  <div class="device-header">
    <div class="device-avatar-wrapper">
      <tui-avatar size="xl" appearance="secondary" [src]="item?.device?.icon || '@tui.monitor-smartphone'"
        [style.color]="'var(--tui-text-secondary)'">
      </tui-avatar>
    </div>
    <div class="device-info">
      <div class="device-name">
        <header tuiHeader="h6">
          <hgroup tuiTitle>
            <h6>{{ item?.device?.name || 'Unknown Device' }}</h6>
            <p tuiSubtitle>{{ item?.location || 'Unknown Location' }}</p>
          </hgroup>
        </header>
      </div>
      <!-- <div class="device-meta-time">{{ relativeLastActivity }}</div> -->
      <!-- <div class="device-badge-row">
        <tui-badge *ngIf="isNew" appearance="accent" size="s" class="new-badge">New</tui-badge>
        <span class="first-sign-in">First sign-in: {{ firstSignInDate }}</span>
      </div> -->
    </div>
  </div>


  <div class="section-divider"></div>

  <div class="recent-activity-section">
    <div class="apps-section-header">
      <app-input-heading [heading]="'RECENT ACTIVITY'" />
    </div>
    <div class="activity-item">
      <div class="dot-container">
        <div class="dot"></div>
      </div>
      <div class="activity-content">
        <div class="activity-text">
          <span class="activity-location">{{ item?.location || 'Unknown Location' }} <span class="activity-time">• {{
              relativeLastActivity }}</span></span>
        </div>
      </div>
    </div>
    <div class="activity-link-wrapper">
      <button tuiLink type="button" [style.text-decoration-line]="'underline'" [style.font-size]="'12px'"
        [textContent]="'How locations and times are determined.'"></button>
    </div>
  </div>

  <!-- <div class="section-divider"></div> -->

  <div class="apps-section">
    <div class="apps-section-header" [style.marginTop]="'1.5rem'">
      <app-input-heading [heading]="'BROWSERS, APPS, AND SERVICES'" />
    </div>
    <div class="app-item">
      <div class="app-icon-container">
        <img [src]="browserIcon" width="20" height="20" [alt]="item?.device?.browser || 'Browser icon'">
      </div>
      <div class="app-name">{{ item?.device?.browser || 'Google Chrome' }}</div>
    </div>
    <div class="app-description">
      Browsers, apps, and services with some access to your account on the device
    </div>
  </div>

  <div class="section-divider"></div>
  <div class="action-buttons-inline">
    <button tuiButton appearance="outline" size="m" class="inline-action-btn unrecognized-btn" (click)="close()">
      <!-- <tui-icon icon="@tui.help-circle" class="btn-icon"></tui-icon> -->
      Cancel
    </button>
    <button tuiButton appearance="primary" size="m" class="inline-action-btn sign-out-btn" (click)="signOut()">
      <tui-icon icon="@tui.log-out" class="btn-icon"></tui-icon>
      Sign out
    </button>

  </div>
</div>